import  http from "./http.js"

export function getApp() {//根据域名获取机构信息
  return http.get("/app/info",{});
}

export function getToken(atiak) {//根据机构信息获取token 
  return http.getPassport("/caccount/token?",{'atiak':atiak});
}
//获取机构内排行榜
export function getOrgRank(token,page,pageSize,beginTime,endTime){//获取机构排名 
  let url ='/reading/rank/accReadingTimeTotalRank';
  let params = { 
      "token":token,
      "page":page,
      "pageSize":pageSize,
      "beginTime":beginTime,
      "endTime":endTime,
      "resourceType":-1,//-1：图书+听书 图书是0，听书是1?
  }
  return http.getByToken(url,params,token);
}

export function getTotalRankOld(appId,token,page,pageSize,beginTime,endTime){//获取机构排名
  //environment.Api_Base_Url.Cahd + 
  let url ='/reading/rank/accReadingTimeTotalRank';
  let params = {
    //"appId":0,//获取所有机构下面的信息
      //"appId":appId,
      "token":token,
      "page":page,
      "pageSize":pageSize,
      "beginTime":beginTime,
      "endTime":endTime,
      "resourceType":-1,//-1：图书+听书 图书是0，听书是1?
  }
  return http.getByToken(url,params,token);
}

export function getTotalRank(appId,token,page,pageSize,beginTime,endTime){//获取机构排名
  //environment.Api_Base_Url.Cahd + 
  let url ='/reading/rank/platformAccReadingTimeTotalRank';
  let params = {
      //"resourceType":0, //0:图书 1：听书 不传查全部
      "token":token,
      "page":page,
      "pageSize":pageSize,
      "beginTime":beginTime,
      "endTime":endTime
  }
  return http.getByToken(url,params,token);
}

